import React, { Component } from 'react'
import { FilterSelect } from '../FilterSelect'
import { SearchAndSelect } from '../SearchAndSelect'
import {
  LIST_ROOM,
  CREATE_BOOKING,
  SPACE_TYPE_LIST,
  SPACE_TYPE_LABEL,
  SPACE_TYPE_OPTIONS,
} from '../../helpers'

export const SpaceTypeFilter = ({ value, onChange, language, colorTheme }) => (
  <FilterSelect
    value={value}
    options={SPACE_TYPE_OPTIONS}
    placeholder={LIST_ROOM.SELECT_TYPE[language]}
    onChange={onChange}
    language={language}
    colorTheme={colorTheme}
  />
)

export class SpaceTypeSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: this.getName(props.value),
      isOpen: false
    }
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props
    if (prevProps.value !== value && SPACE_TYPE_LABEL[value]) {
      this.setState({ text: this.getName(value) })
    }
  }

  getName = (id) => {
    if (!id) return ''
    return SPACE_TYPE_LABEL[id]?.[this.props.language] || id
  }

  getList = () => {
    const keyword = (this.state.text || '').toLowerCase()
    return SPACE_TYPE_LIST
      .map(id => ({ id, name: this.getName(id) }))
      .filter(type => type.name.toLowerCase().includes(keyword))
  }

  search = (text) => {
    this.setState({ text, isOpen: true })
  }

  select = (type) => {
    this.setState({ text: type.name, isOpen: false })
    this.props.onChange(type)
  }

  clear = () => {
    this.props.onChange(null)
    this.search('')
  }

  render() {
    const { value, language, colorTheme, disabled, className, classInput } = this.props
    const { text, isOpen } = this.state

    return (
      <SearchAndSelect
        typeIcon='autosuggest'
        icon='ic_expand-more.svg'
        placeholder={CREATE_BOOKING.SELECT_SPACE_TYPE[language]}
        classInput={classInput}
        className={className}
        keyword={text}
        onChangeSearch={(event) => this.search(event.target.value)}
        empty={value}
        list={this.getList()}
        onClickList={this.select}
        colorTheme={colorTheme}
        clearSearch={this.clear}
        disabled={disabled}
        onFocus={() => {
          this.setState({ isOpen: true })
          if (value) {
            this.search('')
          }
        }}
        onBlur={() => this.setState({ isOpen: false, text: this.getName(this.props.value) })}
        isOpenDropdown={isOpen}
      />
    )
  }
}
